import axios from "../../../../api/axios";
import { User } from "../../../../types/types";
import { entityGenderEnum, entityRoleEnum, entityVerificationStatusEnum } from "../../../../enums/entity.enum";

export interface SearchUsersParams {
  limit: number;
  offset: number;
  searchValue?: string;
  countryId?: string;
  nationalityId?: string;
  gender?: entityGenderEnum;
  verificationStatus?: entityVerificationStatusEnum;
  role?: entityRoleEnum;
  trending?: boolean;
  isFollowing?: boolean;
}

export interface SearchUsersResponse {
  items: User[];
  meta: {
    currentPage: number;
    itemCount: number;
    totalItems: number;
    itemsPerPage: number;
    totalPages: number;
  };
  total: number;
}

export const searchUsers = async (query: URLSearchParams): Promise<SearchUsersResponse> => {
  try {
    const response = await axios.get(`/search/v1/users?${query}`);
    return response.data;
  } catch (err) {
    throw new Error(err + " Failed to search users");
  }
};
